import { Box, CircularProgress } from "@mui/material";

interface IProps {
    /**
     * The size of the component. If using a number, the pixel unit is assumed. If using a string, you need to provide the CSS unit, for example '3rem'.
     *
     * @default 40
     */
    size?: number | string | undefined;
}
/**
 * LoadingIndicator component is used to show a loading indicator. Displayed in the center of the screen with primary color.
 *
 * Extends MUI CircularProgress component.
 *
 */
export const LoadingIndicator = ({ size = 40 }: IProps) => {
    return (
        <Box
            flexGrow={1}
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
        >
            <CircularProgress size={size} />
        </Box>
    );
};
